function toNumber(value, fallback = 0) {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

function clone(value) {
  if (value === undefined || value === null) return value;

  if (typeof structuredClone === "function") {
    return structuredClone(value);
  }

  return JSON.parse(JSON.stringify(value));
}

function normalizeCabinetForRun(cabinet = {}, runType = "base") {
  const next = { ...cabinet };

  const role = String(next.cabinetRole || "").toLowerCase();
  const frontType = String(next.frontType || "").toLowerCase();

  if (role === "drawer_base" || frontType === "drawers") {
    next.frontType = "drawers";

    if (toNumber(next.drawerCount, 0) < 2) {
      next.drawerCount = 3;
    }
  }

  if (role === "dishwasher") {
    next.frontType = "none";
    next.applianceType = "dishwasher";
  }

  if (role === "sink_base") {
    next.frontType = "doors";
    next.applianceType = "sink";
  }

  if (role === "fridge_tower") {
    next.frontType = "doors";
    next.applianceType = "fridge";
  }

  if (role === "oven_tower") {
    next.frontType = "doors";
    next.applianceType = "oven";
  }

  if (runType === "wall") {
    next.frontType = "doors";

    if (
      role === "dishwasher" ||
      role === "drawer_base" ||
      role === "sink_base" ||
      role === "fridge_tower" ||
      role === "oven_tower"
    ) {
      next.cabinetRole = "standard";
      next.applianceType = "none";
    }
  }

  return next;
}

function normalizeRun(run = {}) {
  const type = String(run.type || "base").toLowerCase();

  const next = {
    ...run,
    type,
    startX: toNumber(run.startX, 0),
    startZ: toNumber(run.startZ, 0),
    rotationY: toNumber(run.rotationY, 0),
    cabinets: Array.isArray(run.cabinets) ? run.cabinets : [],
  };

  if (type === "base") {
    next.defaultHeight = toNumber(run.defaultHeight, 720);
    next.defaultDepth = toNumber(run.defaultDepth, 560);
    next.floorOffset = toNumber(run.floorOffset, 0);
  }

  if (type === "wall") {
    next.defaultHeight = toNumber(run.defaultHeight, 700);
    next.defaultDepth = toNumber(run.defaultDepth, 320);
    next.floorOffset = toNumber(run.floorOffset, 1400);
  }

  if (type === "tall") {
    next.defaultHeight = toNumber(run.defaultHeight, 2000);
    next.defaultDepth = toNumber(run.defaultDepth, 560);
    next.floorOffset = toNumber(run.floorOffset, 0);
  }

  next.cabinets = next.cabinets.map((cabinet) =>
    normalizeCabinetForRun(cabinet, type)
  );

  return next;
}

export function normalizeKitchenIntent(intent = {}) {
  const next = clone(intent) || {};

  next.version = 1;
  next.layoutType = next.layoutType || "linear";

  const runs = Array.isArray(next.runs) ? next.runs : [];

  next.runs = runs.map(normalizeRun);

  return next;
}